import React from "react";
import styled from "styled-components";
import Main from "../main";
import { useNavigate } from "react-router-dom";

const WelcomeContainer = styled.div`
    width: calc(100% - 620px);
    max-width: 460px;
    height: 560px;
    padding: 42px 24px;

    border-radius: 16px;
    background: var(--Surface-Brand, #652278);
    box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.25);

    @media (max-width: 1080px) {
        width: 80%;
        max-width: 600px;
    }

    @media (max-width: 768px) {
        width: 90%;
        max-width: 500px;
    }

    @media (max-width: 328px) {
        width: 100%;
        padding: 24px;
    }

`;
const TitleDiv = styled.div`
    width: 100%;
`;
const Title = styled.h1`
    color: #FFF;
    text-align: center;
    font-size: 36px;
    font-weight: 700;
`;
const Section = styled.section`
    margin-top: 124px;
    display: flex;
    gap: 32px;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`;
const ButtonContainer = styled.div`
    width: calc(100% - 48px);
    height: 80px;
    padding: 13px;

    display: flex;
    align-items: center;
    justify-content: space-between;
    border-radius: 8px;
    background: var(--Surface-White-BG, #FFF);
`;
const LogoTextContainer = styled.div`
    display: flex;
    gap: 32px;
    align-items: center;
`;
const IconDiv = styled.div``;
const ArrowIcon = styled.img`
    width: 32px;
    height: 32px;
`;
const ButtonText = styled.p`

    color: #F37021;
    font-size: 16px;
    font-weight: 700;
    text-transform: uppercase;
`;
const UserLogoDiv = styled.div``;
const UserLogo = styled.img`
    width: 54px;
    height: 54px;
`;

export default function CommonLandingPage() {
    const  navigate =  useNavigate();

    const navigateToDealer = () => {
        navigate('/login');
    }

    const navigateToNbfc = () => {
        navigate('/nbfclogin');
    }

	return (
		<Main style={{width:'100%', height:'100vh', padding:'10px',display:'flex', alignItems:'center', justifyContent: "center" }}>
			<WelcomeContainer>
				<TitleDiv>
					<Title>WELCOME</Title>
				</TitleDiv>
				<Section>
					<ButtonContainer onClick={navigateToNbfc}>
						<LogoTextContainer>
							<UserLogoDiv>
								<UserLogo src="../assets/portal/nbfc_portal.svg" alt="nbfc Portal Logo" />
							</UserLogoDiv>
							<ButtonText>NBFC PORTAL</ButtonText>
						</LogoTextContainer>
						<IconDiv>
							<ArrowIcon src="../assets/icons/arrowright.svg" alt="arrowright" />
						</IconDiv>
					</ButtonContainer>
					<ButtonContainer onClick={navigateToDealer}>
						<LogoTextContainer>
							<UserLogoDiv>
								<UserLogo src="../assets/portal/dealer_portal.svg" alt="Dealer Portal Logo" />
							</UserLogoDiv>
							<ButtonText>DEALER PORTAL</ButtonText>
						</LogoTextContainer>
						<IconDiv>
							<ArrowIcon src="../assets/icons/arrowright.svg" alt="arrowright" />
						</IconDiv>
					</ButtonContainer>
				</Section>
			</WelcomeContainer>
		</Main>
	);
}
